import { useEffect, useState } from "react";
import usePhaser from "../hooks/usePhaser";

const Scene = ({ name, children }) => {
  const [isActive, setActive] = useState(false);
  const { game, scene } = usePhaser();
  
  useEffect(() => {
    if (game?.scene.isActive(name) && scene) {
      setActive(true);
    }
  }, [game, name, scene]);

  return isActive ? children : null;
};

export default Scene;
